import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@citypantry/state';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthSelectors } from '../state/auth.select';

@Injectable({
  providedIn: 'root',
})
export class CanAccessJefbGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) {
  }

  public canActivate(): Observable<boolean | UrlTree> {
    return this.store.select(AuthSelectors.navigationPermissions.canAccessJefb).pipe(
      map((canAccessJefb) => !!canAccessJefb || this.router.parseUrl('/')),
    );
  }
}
